import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import IdleTimer from 'react-idle-timer'
import { Loader, Video, VideoDescription } from '@/components'
import TimeTracking, {
  TYPE_VIDEO,
} from '@/components/TimeTracking/TimeTracking'
import { WATCH_TAB } from '@/stores/models/section'
import { getIdleTimeThreshold } from '@/utils/helpers'

// const CoursePageWatchMessages = defineMessages({
//   noLectureNotes: {
//     defaultMessage: 'No Read available.',
//     description:
//       'Description displayed when the section has no lecture notes available.',
//     id: 'CoursePage.noLectureNotes',
//   },
// })

@observer
export default class CoursePageWatch extends Component {
  componentDidMount() {
    const {
      courseContentfulId,
      section,
      sectionContentfulId,
      unitContentfulId,
    } = this.props
    const { isLoadingVideo: isLoadingSectionVideo, video: sectionVideo } =
      section
    if (!sectionVideo && !isLoadingSectionVideo) {
      section.loadVideo(
        courseContentfulId,
        unitContentfulId,
        sectionContentfulId,
      )
    }
  }
  renderContent() {
    const {
      isOpenIdleModal,
      isOpenMemoryBoosterModal,
      onIdle,
      onOpenActivityModal,
      section,
    } = this.props
    const {
      isLoadingVideo: isLoadingSectionVideo,
      video: sectionVideo,
      videoDescription: sectionVideoDescription,
    } = section
    const {
      entryCaptionsUrl: videoEntryCaptionsUrl,
      entryId: videoEntryId,
      entryPath: videoEntryPath,
      entrypoint: videoEntrypoint,
      entryThumbnailUrl: videoEntryThumbnailUrl,
      entryUrl: videoEntryUrl,
      type: videoType,
      url: videoURL,
    } = sectionVideo || {}
    if (!sectionVideo || isLoadingSectionVideo) return <Loader />
    return (
      <Fragment>
        {!isOpenMemoryBoosterModal ? (
          <TimeTracking
            isIdle={isOpenIdleModal}
            section={section}
            what={TYPE_VIDEO}
          />
        ) : null}
        <IdleTimer
          onIdle={onIdle}
          startOnLoad
          timeout={getIdleTimeThreshold(WATCH_TAB)}
        />
        {sectionVideoDescription ? (
          <VideoDescription
            innerHtml={sectionVideoDescription}
            onOpenImageModal={onOpenActivityModal}
          />
        ) : null}
        <Video
          entryCaptionsUrl={videoEntryCaptionsUrl}
          entryId={videoEntryId}
          entryPath={videoEntryPath}
          entrypoint={videoEntrypoint}
          entryThumbnailUrl={videoEntryThumbnailUrl}
          entryUrl={videoEntryUrl}
          type={videoType}
          url={videoURL}
        />
      </Fragment>
    )
  }
  render() {
    const { section } = this.props
    const { hasVideo: hasVideoSection } = section || {}
    if (!hasVideoSection) return <div>No video</div>
    return <div className="CoursePageWatch">{this.renderContent()}</div>
  }
}
